"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmailTemplates;
(function (EmailTemplates) {
    EmailTemplates["accountActivated"] = "account_activated";
    EmailTemplates["accountArchived"] = "account_archived";
    EmailTemplates["accountMigrated"] = "account_migrated";
    EmailTemplates["activityAssigned"] = "activity_assigned";
    EmailTemplates["complianceReport"] = "user_compliance_report";
    EmailTemplates["courseActivated"] = "course_activated";
    EmailTemplates["courseApproved"] = "course_approved";
    EmailTemplates["courseAssigned"] = "course_assigned";
    EmailTemplates["courseCertificate"] = "course_certificate";
    EmailTemplates["courseFeedback"] = "course_feedback";
    EmailTemplates["courseRegistration"] = "course_registration";
    EmailTemplates["courseReview"] = "course_review";
    EmailTemplates["eventCertificate"] = "event_certificate";
    EmailTemplates["eventEvaluation"] = "event_evaluation";
    EmailTemplates["eventInvitation"] = "event_invitation";
    EmailTemplates["eventPostWork"] = "event_post_work";
    EmailTemplates["eventRegistration"] = "event_registration";
    EmailTemplates["eventRegistrationReminder"] = "event_registration_reminder";
    EmailTemplates["eventRegistrationUpdate"] = "event_registration_update";
    EmailTemplates["eventUpdate"] = "event_update";
    EmailTemplates["eventWaitlist"] = "event_waitlist";
    EmailTemplates["firmInvite"] = "company_invite";
    EmailTemplates["firmMigrate"] = "company_migrate";
    EmailTemplates["firmMigrateAcceptReject"] = "firm_migrate_accept_reject";
    EmailTemplates["teamLeaderAssigned"] = "company_team_leader";
    EmailTemplates["trackAssigned"] = "company_track";
})(EmailTemplates = exports.EmailTemplates || (exports.EmailTemplates = {}));
//# sourceMappingURL=emailTemplates.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/types/dist/enums/emailTemplates.js
// module id = 873
// module chunks = 0